import React, { FC } from 'react';
import { getContext, I18n } from '@fiverr-private/fiverr_context';
import pathfinder from '@fiverr-private/pathfinder';
import { headerLinkClicked, HEADER_LINKS } from '../../../../../utils/bi';

const GoToFiverrLink: FC = () => {
  const { userId } = getContext();

  return (
    // eslint-disable-next-line react/jsx-no-target-blank
    <a
      href={pathfinder('root')}
      target="_blank"
      className="fiverr-link nav-link"
      onClick={() => headerLinkClicked(userId, HEADER_LINKS.GO_TO_FIVERR)}
    >
      <I18n k="fiverr_guides.header.go_to_fiverr" />
    </a>
  );
};

export default GoToFiverrLink;
